export default __webpack_public_path__ + "static/media/virgo.37abca4d.png";